var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 0H9V1H3V0ZM11 2H0V4H1V11.91C0.998675 12.1848 1.05183 12.4572 1.15639 12.7114C1.26096 12.9655 1.41486 13.1965 1.60919 13.3908C1.80353 13.5851 2.03446 13.739 2.28863 13.8436C2.5428 13.9482 2.81517 14.0013 3.09 14H8.73C9.33204 14 9.90942 13.7608 10.3351 13.3351C10.7608 12.9094 11 12.332 11 11.73V4H12V2H11ZM5 12H4V5H5V12ZM8 12H7V5H8V12Z",
    fill: "#464646"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteicon);
export default __webpack_public_path__ + "static/media/deleteicon.792fbd399fd21559b2f37df16485423f.svg";
export { ForwardRef as ReactComponent };